import {createContext} from 'react';

// export const API_BASE_URL = 'http://localhost:8081/api/v1';
export const API_BASE_URL = 'https://api.tigoon-connect.com/api/v1';
export const APP_NAME = "FRONT_APP";
export const LOCAL_STORAGE_KEYS = {
   ACCESS_TOKEN : 'accessToken',
   CURRENT_USER : 'currentUser'
};

export const ACCESS_TOKEN = 'accessToken';
export const CURRENT_USER = 'currentUser';

export const AuthContext = createContext('AUTH_CONTEXT');
export const AppContext = createContext('APP_CONTEXT');





